export default __webpack_public_path__ + "static/18-e1b88315631dff1cb904b387f36bdde5.jpg";